var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgType2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0576 10.9051C10.7606 10.9051 11.3305 10.3486 11.3305 9.66215C11.3305 8.97568 10.7606 8.41919 10.0576 8.41919C9.35458 8.41919 8.78467 8.97568 8.78467 9.66215C8.78467 10.3486 9.35458 10.9051 10.0576 10.9051Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98143 10.9051C6.68446 10.9051 7.25437 10.3486 7.25437 9.66215C7.25437 8.97568 6.68446 8.41919 5.98143 8.41919C5.27841 8.41919 4.7085 8.97568 4.7085 9.66215C4.7085 10.3486 5.27841 10.9051 5.98143 10.9051Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06298 7.54819C4.766 7.54819 5.33591 6.99169 5.33591 6.30522C5.33591 5.61875 4.766 5.06226 4.06298 5.06226C3.35995 5.06226 2.79004 5.61875 2.79004 6.30522C2.79004 6.99169 3.35995 7.54819 4.06298 7.54819Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01952 7.54819C8.72254 7.54819 9.29246 6.99169 9.29246 6.30522C9.29246 5.61875 8.72254 5.06226 8.01952 5.06226C7.3165 5.06226 6.74658 5.61875 6.74658 6.30522C6.74658 6.99169 7.3165 7.54819 8.01952 7.54819Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9155 7.54819C12.6185 7.54819 13.1885 6.99169 13.1885 6.30522C13.1885 5.61875 12.6185 5.06226 11.9155 5.06226C11.2125 5.06226 10.6426 5.61875 10.6426 6.30522C10.6426 6.99169 11.2125 7.54819 11.9155 7.54819Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0279 4.53697C10.5412 4.53697 10.9572 4.10748 10.9572 3.57769C10.9572 3.04789 10.5412 2.61841 10.0279 2.61841C9.5147 2.61841 9.09863 3.04789 9.09863 3.57769C9.09863 4.10748 9.5147 4.53697 10.0279 4.53697Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13146 4.53697C6.6447 4.53697 7.06076 4.10748 7.06076 3.57769C7.06076 3.04789 6.6447 2.61841 6.13146 2.61841C5.61821 2.61841 5.20215 3.04789 5.20215 3.57769C5.20215 4.10748 5.61821 4.53697 6.13146 4.53697Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 0.874547
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00323 0.760498H12.1555C12.1555 0.760498 13.0104 1.33852 13.3705 1.73569C13.7306 2.13286 14.0737 2.66686 14.3135 3.09828C14.5533 3.5297 14.7476 3.91611 14.9129 4.41705C15.0783 4.91798 15.2298 5.4399 15.2726 6.09546C15.3153 6.75102 15.2532 7.64802 15.0928 8.31337C14.9323 8.97871 14.6343 9.58419 14.3734 10.0517C14.1126 10.5193 13.9215 10.7562 13.5942 11.1307C13.2668 11.5052 12.8367 11.9277 12.3953 12.2696C11.9539 12.6116 11.4895 12.9246 10.9567 13.1688C10.4238 13.413 9.2183 13.7083 9.2183 13.7083C9.2183 13.7083 7.58588 13.9272 6.28108 13.4685C5.76244 13.2862 5.42258 13.224 4.84243 12.929C4.11568 12.5595 3.41571 12.0909 2.8643 11.4904C2.10647 10.6649 1.49911 9.66967 1.12594 8.61308C0.830453 7.77642 0.733684 6.86228 0.766283 5.97557C0.791047 5.30198 0.94859 4.62834 1.18589 3.99744C1.38744 3.46157 1.72945 2.94613 2.02509 2.49886C2.31431 2.06132 2.82356 1.58167 3.16402 1.29999C3.50448 1.01831 4.00323 0.760498 4.00323 0.760498Z",
    stroke: "hsl(from var(--primary-color) h s l)",
    strokeWidth: 1.52095,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType2);
export default __webpack_public_path__ + "static/media/type2.4d62adff8ebe6fbdfa7fdc26986a7116.svg";
export { ForwardRef as ReactComponent };